import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3a6f9d36")

_pushScopeId("data-v-3a6f9d36")
const _hoisted_1 = { class: "product-item" }
const _hoisted_2 = { class: "info clearfix" }
const _hoisted_3 = { class: "fl" }
const _hoisted_4 = { class: "fl txtbox" }
const _hoisted_5 = { class: "name" }
const _hoisted_6 = { class: "spec" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "grey" }, "规格：", -1)
const _hoisted_8 = { class: "desc" }
const _hoisted_9 = { class: "descitem" }
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "grey" }, "配料：", -1)
const _hoisted_11 = { class: "descitem" }
const _hoisted_12 = /*#__PURE__*/_createVNode("span", { class: "grey" }, "使用方法：", -1)
const _hoisted_13 = { class: "descitem" }
const _hoisted_14 = /*#__PURE__*/_createVNode("span", { class: "grey" }, "禁忌：", -1)
const _hoisted_15 = { class: "descitem" }
const _hoisted_16 = /*#__PURE__*/_createVNode("span", { class: "grey" }, "说明：", -1)
const _hoisted_17 = { class: "product-detail" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_van_icon = _resolveComponent("van-icon")
  const _component_van_popup = _resolveComponent("van-popup")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("img", {
            class: "img",
            src: _ctx.product.coverUrl,
            alt: "产品图片"
          }, null, 8, ["src"])
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createTextVNode(_toDisplayString(_ctx.product.name), 1),
            _createVNode(_component_van_icon, {
              name: "info-o",
              class: "nameicon",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showProductDetail = true))
            })
          ]),
          _createVNode("div", _hoisted_6, [
            _hoisted_7,
            _createTextVNode(_toDisplayString(_ctx.product.specification), 1)
          ])
        ])
      ]),
      _createVNode("div", _hoisted_8, [
        _createVNode("div", _hoisted_9, [
          _hoisted_10,
          _createTextVNode(_toDisplayString(_ctx.product.material), 1)
        ]),
        _createVNode("div", _hoisted_11, [
          _hoisted_12,
          _createTextVNode(_toDisplayString(_ctx.product.useFunction), 1)
        ]),
        _createVNode("div", _hoisted_13, [
          _hoisted_14,
          _createTextVNode(_toDisplayString(_ctx.product.taboo), 1)
        ]),
        _createVNode("div", _hoisted_15, [
          _hoisted_16,
          _createTextVNode(_toDisplayString(_ctx.product.description), 1)
        ])
      ])
    ]),
    _createVNode(_component_van_popup, {
      show: _ctx.showProductDetail,
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => (_ctx.showProductDetail = $event)),
      round: true,
      closeable: true,
      "close-icon": "clear"
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_17, [
          _createVNode("div", {
            innerHTML: _ctx.product.content
          }, null, 8, ["innerHTML"])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
})